import React, { useState, useEffect } from 'react';
import { RotateCcw } from 'lucide-react';

const OrientationPrompt = () => {
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    const checkOrientation = () => {
      // Only show on mobile devices
      if (window.innerWidth <= 768) {
        setShowPrompt(window.innerHeight > window.innerWidth);
      } else {
        setShowPrompt(false);
      }
    };

    checkOrientation();
    window.addEventListener('resize', checkOrientation);
    window.addEventListener('orientationchange', checkOrientation);

    return () => {
      window.removeEventListener('resize', checkOrientation);
      window.removeEventListener('orientationchange', checkOrientation);
    };
  }, []);

  if (!showPrompt) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4">
      <div className="text-center">
        <div className="flex justify-center mb-6">
          <div className="relative">
            <RotateCcw className="w-16 h-16 text-white animate-spin" />
          </div>
        </div>
        <h2 className="text-white text-xl font-semibold mb-2">
          Please Rotate Your Device
        </h2>
        <p className="text-gray-300">
          This app works best in landscape orientation
        </p>
      </div>
    </div>
  );
};

export default OrientationPrompt;